
import { useEffect, useRef } from 'react';

function Process() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const steps = entry.target.querySelectorAll('.process-step');
            steps.forEach((step, i) => {
              setTimeout(() => {
                step.classList.add('opacity-100', 'translate-y-0');
                step.classList.remove('opacity-0', 'translate-y-8');
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const steps = [
    {
      number: '01',
      title: 'Audit & Architecture',
      description: 'Operational assessment and opportunity mapping.',
    },
    {
      number: '02',
      title: 'System Design',
      description: 'Structured automation blueprint aligned to growth goals.',
    },
    {
      number: '03',
      title: 'Deployment',
      description: 'Precision implementation across CRM, communications, and workflows.',
    },
    {
      number: '04',
      title: 'Optimization',
      description: 'Continuous refinement for performance lift and scalability.',
    },
  ];

  return (
    <section id="process" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <p className="text-sm font-medium tracking-[0.2em] uppercase text-[#2DD4BF] mb-4">
            How We Work
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-semibold text-gray-900 tracking-tight">
            Our Process
          </h2>
        </div>

        <div ref={sectionRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="process-step opacity-0 translate-y-8 transition-all duration-700 ease-out relative text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 rounded-full bg-gray-900">
                <span className="text-sm font-semibold text-white">{step.number}</span>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(50%+40px)] w-[calc(100%-80px)] h-px bg-gray-200"></div>
              )}

              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed font-light">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
